function notesRotate() {
    const visibleClass = 'donation-notes__notes__note--visible';
    document.querySelectorAll('.donation-notes').forEach((notesContainer) => {
        const notes = notesContainer.querySelectorAll('.donation-notes__notes__note');
        const activenotes = notesContainer.querySelector('.'+visibleClass);

        if (notes.length > 0) {
            const activeIndex = [].indexOf.call(notes, activenotes);
            if (activenotes !== null) {
                activenotes.classList.remove(visibleClass);
            }
            if (activenotes === null || notes[activeIndex + 1] === undefined) {
                //activate first item / rotate back to first
                notes[0].classList.add(visibleClass);
            }
            else {
                //move to the next
                notes[activeIndex + 1].classList.add(visibleClass);
            }
            setTimeout(notesRotate, 5000);
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    notesRotate();
});
